<template>
    <div class="py-3 create-user-main-container">
        <div class="d-flex mb-4 title-container">
            <img src="../../../assets/images/title-icon.png" alt="">
            <h3 class="h3">Edit User</h3>
        </div>
        <div id="createUserContainer" class="tabcontent">
            <form class="form-container row d-flex flex-column justify-content-between gap-3">
                <div class="row col-12 inputs-container">
                    <div class="col-md-6">
                        <label for="inputName" class="form-label">Name<span style="color: #E95626">*</span></label>
                        <input type="text" @input="changeHandler($event, errors, 'name')" v-model="userData.name"
                            class="custom-input form-control" id="inputName" placeholder="Name">
                        <div v-if="errors['name'].length > 0">
                            <div v-for="msg in errors['name']" class="err text-danger">{{ msg }}</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="inputEmail" class="form-label">Email<span style="color: #E95626">*</span></label>
                        <div class="d-flex flex-nowrap  mb-1">
                            <input type="email"
                                @input="[changeHandler($event, errors, 'email'), setData($event, 'email')]"
                                v-model="userData.email" class="custom-input form-control" id="inputEmail"
                                placeholder="Email@example.com"
                                :style="userData.file != null ? { 'pointerEvents': 'none' } : { 'pointerEvents': 'auto' }">
                            <div class="input-group-append">
                                <span class="input-group-text">@{{ organizationDomain }}</span>
                            </div>
                        </div>
                        <div v-if="errors['email'].length > 0">
                            <div v-for="msg in errors['email']" class="err text-danger">{{ msg }}</div>
                        </div>
                    </div>
                </div>
                <div class="row col-12 inputs-container ">
                    <div class="col-md-6 ">
                        <label class="mb-2">Password</label>
                        <input type="password" class="form-control custom-input" v-model="this.userData.password"
                            @input="[passWordOnChange($event, errors, 'password'), setData($event, 'password')]"
                            @change="passWordOnChange($event, errors, 'password')" id="password" name="password"
                            placeholder="Enter Password">

                        <div v-if="errors['password'].length > 0">
                            <div v-for="msg in errors['password']" class="text-danger">{{ msg }}<br></div>
                        </div>
                    </div>
                    <div class="col-md-6 ">
                        <label class="mb-2">Confirm Password</label>
                        <input type="password" class="form-control custom-input"
                            v-model="this.userData.password_confirmation"
                            @input="[passWordOnChange($event, errors, 'password_confirmation'), setData($event, 'password_confirmation')]"
                            @change="passWordOnChange($event, errors, 'password_confirmation')"
                            id="password_confirmation" name="password_confirmation" placeholder="Confirm Password">

                        <div v-if="errors['password_confirmation'].length > 0">
                            <div v-for="msg in errors['password_confirmation']" class="text-danger">{{ msg }}</div>
                        </div>
                    </div>
                </div>

                <div class="row col-12">
                    <div class="w-100">
                        <label for="inputEmail" class="form-label">Roles</label>
                        <!--                        <select id="assign" v-model="userData.roles" class="form-control designOfAssign">-->
                        <!--                            <option value="" selected disabled>Assign Role To User</option>-->
                        <!--                            <option v-for="role in userRoles" :key="role.id" :value="role.name">{{role.name}}</option>-->
                        <!--                        </select>-->
                        <Multiselect v-model="userData.roles" :options="userRoles" class="designOfAssign"
                            placeholder="Assign Role to User" ref="multiselect3" />
                    </div>
                </div>
            </form>
        </div>
        <div class="save-button-container">
        <router-link class="back-route" ref="backBtn" @click="backHandler" :to="'/super/users'">
            <button class="save-button back-btn">Back</button>
        </router-link>
        <SaveBtn class="save-button" @save="submitHandler" />
    </div>
    </div>
    
    <AlartModal state="error" v-if="showErrorModal" :message="responseErrorMessage" imagePath="close.png"
        @close-modal="showErrorModal = false" />

    <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
        @close-modal="confirmModalHandler($event)" />
</template>

<script>
import repository from "../../../api-services/repository";
import changeHandler from '../../../validation/superUserValidation'
import ConfirmationModal from "../../components/ConfirmationModal";
import SaveBtn from '../../components/SaveBtn';
import AlartModal from "../../components/AlartModal";
import { computed } from "vue";
import Multiselect from '@vueform/multiselect';

export default {
    name: 'user-superEdit',
    components: {
        SaveBtn,
        Multiselect,
        AlartModal,
        ConfirmationModal
    },
    async mounted() {
        this.showUser();
        this.getRoles();
        await this.$store.dispatch('activeTap', 'super-users');
    },
    data() {
        return {
            changeHandler,
            userRoles: [],
            organizationDomain: 'caduceuslane.com',
            userData: {
                id: '',
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
                roles: ''
            },
            errors: {
                name: [],
                email: [],
                password: [],
                password_confirmation: [],
                isError: false
            },
            showErrorModal: false,
            errorMessages: [],
            responseErrorMessage: '',
            isPassWordChange: false,
            PassWordsNotEmpty: '',
            showModal: false,
            isFull: false,
            isErrorTag: false,
            isData: {
                name: false,
                email: false,
                password: false,
                password_confirmation: false,
                file: false
            },
            ownerID: this.$store.state?.auth?.user ? this.$store.state?.auth?.user.data.id : null,
            isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
            confirmModal: computed(() => this.$store.state.settings.confirmModal),
            confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
        }
    },
    methods: {
        async backHandler() {
            let setDataFlag = this.$store.state.settings.setDataFlag;
            if (setDataFlag) {
                this.isFull = true;
                await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
            } else {
                await this.$store.dispatch('setDataFlag', false);
                this.isFull = false
            }
        },
        setData(e, type) {
            let val = e.target.value;

            if (val !== '') {
                this.isData[type] = true;
            } else {
                this.isData[type] = false;
            }

            if (this.isData[type]) {
                this.$store.dispatch('setDataFlag', true);
            } else {
                this.$store.dispatch('setDataFlag', false);
            }
        },
        async confirmModalHandler(event) {
            this.isFull = false;
            await this.$store.dispatch('setConfirmModal', false);
            if (event) {
                await this.$store.dispatch('setDataFlag', false);
                // await this.$router.push('/roles');
                await this.$router.push('/' + this.$store.state.settings.currentRoute);
            }
        },
        async showUser() {
            try {
                const userId = this.$route.params.id;
                const response = await repository.show('users', userId);
                console.log(response.data.data);
                this.userData.name = response.data.data.name;
                this.userData.email = response.data.data.email.split('@')[0];
                this.userData.roles = response.data.data.role[0];
                this.$refs.multiselect3.select({ value: response.data.data.role[0], label: response.data.data.role[0] });
            } catch (e) {
                console.log(e);
            }
        },
        async getRoles() {
            const response = await repository.getRoles();
            for (let i = 0; i < response.data.data.length; i++) {
                this.userRoles.push({ label: response.data.data[i].name, value: response.data.data[i].name });
            }
        },
        backHandler() {
            this.$store.dispatch('setEditFlag', false);
        },
        checkPasswordFields(password, password_confirmation) {
            return {
                status: password != '' && password_confirmation != '',
                emptyOne: (password === '' && password_confirmation === '') ? 'empty' :
                    password === '' ? 'password' :
                        password_confirmation === '' ? 'password_confirmation' : 'null'
            };
        },
        
        passWordOnChange(event, elmErrors, elmName) {
            const { isError } = changeHandler(event, elmErrors, elmName)
            const passwordInput = document.getElementById('password').value;
            const passwordConfirmationInput = document.getElementById('password_confirmation').value;
            const { status, emptyOne } = this.checkPasswordFields(passwordInput, passwordConfirmationInput);
            if (emptyOne === 'null') {
                this.isErrorTag = false;
                this.errors.isError = false;
                this.errors.password = "";
                this.errors.password_confirmation ="";
                changeHandler(event, elmErrors, elmName)
            } else if (emptyOne == 'empty') {
                this.isErrorTag = false;
                this.errors.isError = false;
                // changeHandler(event, elmErrors, elmName)
                this.errors.password ='';
                this.errors.password_confirmation ='';

            } else if (emptyOne !== 'null') {
                this.isErrorTag = true;
                this.errors.isError = true;
                this.errors[emptyOne][0] = '*Required';

            }
            if (status && passwordInput !== passwordConfirmationInput) {
                this.isErrorTag = true;
                this.errors.isError = true;
                this.errors.password[0] = 'Passwords do not match';
                this.errors.password_confirmation[0] = 'Passwords do not match';

            }
            if (event.target.value !== '') {
                this.isPassWordChange = false;
            }

            this.isPassWordChange = isError
            this.PassWordsNotEmpty = emptyOne

        },
        areAllErrorsEmpty() {
            if (!this.errors) return true;
            const { isError, ...errorArrays } = this.errors;
            console.log(isError, errorArrays, this.errors)
            return !isError && Object.keys(errorArrays).every(key => errorArrays[key].length === 0)
        },
        async submitHandler() {
            this.errorMessages = [];

            if (!this.areAllErrorsEmpty()) {
console.log("fffffffffffffffffff")
                return false
            }
            try {
                if (this.userData.name === '') {
                    this.isErrorTag = true;
                    this.errors.isError = true;
                    this.errors['name'][0] = '*Required';
                }
                if (this.userData.email === '') {
                    this.isErrorTag = true;
                    this.errors.isError = true;
                    this.errors['email'][0] = '*Required';
                }
                // if (this.userData.password === '' && this.userData.password_confirmation === '') {
                //     this.isErrorTag = false;
                //     this.errors.isError = false;
                //     this.errors['password'][0] = null;
                //     this.errors['password_confirmation'][0] = null;
                // }
                // if (this.userData.password_confirmation === '' && this.userData.password != '') {
                //     this.isErrorTag = true;
                //     this.errors.isError = true;
                //     this.errors['password'][0] = '*Required';
                // }
                // if (this.userData.password_confirmation != '' && this.userData.password === '') {
                //     this.isErrorTag = true;
                //     this.errors.isError = true;
                //     this.errors['password_confirmation'][0] = '*Required';
                // }
                if (this.userData.roles === '') {
                    this.isErrorTag = true;
                    this.showErrorModal = true;
                    this.responseErrorMessage = "Please Select a Role to Assign to Users";
                } else {
                    const { status, emptyOne } = this.checkPasswordFields(this.userData.password, this.userData.password_confirmation);
                    if (!this.errors.isError) {
                        this.isErrorTag = false;
                        const userId = this.$route.params.id;
                        let usersData = await repository.update('users', userId, {
                            name: this.userData.name,
                            email: this.userData.email + ('@' + this.organizationDomain),
                            role: this.userData.roles,
                            ...(status === true && emptyOne !== 'empty' && {
                                password: this.userData.password,
                                password_confirmation: this.userData.password_confirmation
                            })
                        });
                        await this.$store.dispatch('setDataFlag', false);
                        await this.$store.dispatch('setSuccessModal', true);
                        await this.$store.dispatch('setSueccessMessage', usersData.data.message);

                        setTimeout(() => {
                            this.$router.push({ name: 'user-superIndex' });
                        }, 1000);
                    }
                }


            } catch (e) {
                console.log(e)
                await this.$store.dispatch('setErrorModal', true);
                await this.$store.dispatch('setErrorMessage', e?.response?.data?.message);
                await this.$store.dispatch('setDataFlag', false);
            }
        }

    }

}
</script>

<style scoped>

.back-btn{
    background-color: #707070 !important;
    
}
.title-container{
    align-items: center;
    margin-bottom: 2% !important;
}
.title-container img{
    margin-bottom:0;
    padding-right: 10px;
}

.text-danger{
    font-size: 13px;
}
.create-user-main-container{
    padding-inline: 40px;
}

.title-container .h3{
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom:0;
    font-size: calc(1rem+0.5vw);
}
#createUserContainer{
    border: 1px solid var(--table-color-data);
    background-color: var(--table-color-data);
    padding: 23px 0 23px 23px !important;
    border-radius: 15px;
    height: auto;
    overflow-y: unset;

}
label{
        font-weight: 600;
}
input,
input::placeholder,
.designOfAssign,
.designOfAssign :deep(.multiselect-placeholder)
{
    background-color: var(--input-background);
    color: var(--input-color) !important;
    font-weight: normal;
    font-size: 13px;
    font-style: italic;
    opacity:1 !important;
}
.input-group-text {
    margin-left: 10px;
    height: 38px;
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
    font-size: 12px;
}

.cssGap {
    gap: 20px;
}

/* .cssDesignRole {
    position: relative;
    right: 16px;
} */

.hrAll {
    display: flex;
    width: 97%;
}

.textH5 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.designOfAssign {
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
    
    width: 100%;
}

.err {
    overflow-y: auto;
    min-height: 30px;
    max-height: 170px;
}

.custom-input,
.custom-input:focus,
.form-control {
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
}
.multiselect-caret{
    background-color: #848484 !important;
}




.upload-file {
    background-color: #021A24;
    border: 1px solid #6F8896;
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
    display: flex;
}

.upload-file2 {
    background-color: #021A24;
    border: 1px solid #6F8896;
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
}

.form-container {
    gap: 20px;
}

.error-container {
    max-height: 250px;
    min-height: 10px;
    height: 90px;
    padding: 10px;
    margin-top: 40px;
    overflow-y: auto;
}

.inputs-container {
    height: 80px;
}
.save-button{
    border: none;
    color: #fff;
    background-color: var(--btn-bg-color);
    padding: 0px 50px;
    border-radius: 5px;
    font-weight: normal;
    font-size: 18px;
    height: 100%;
}
.back-route{
    margin-right: 10px;
    font-size: 18px;
}
.save-button-container{
        margin-top: 2vh;
        display: flex;
        justify-content: end;
        width: 100%;
        height: 35px;
}
</style>